import React, { useState } from "react";
import Context from "./index";
import { create, getAll } from "../../Api/WebApi";
import { message } from "antd";
import { trackAddToCart } from "../../Utils/TrackingService";
import { CRMTracker } from "../../Api/CRMTracker";

const CartProvider = ({ children, ...props }) => {
  const [cartListLoader, setCartListLoader] = useState(false);
  const [cartList, setCartList] = useState([]);
  const [cartDeleteLoader, setCartDeleteLoader] = useState(false);
  const [cartAddLoader, setCartAddLoader] = useState(false);
  const [cartUpdateLoader, setCartUpdateLoader] = useState(false);
  const [currentCart, setCurrentCart] = useState(null);
  const [couponText, setCouponText] = useState("");
  const [couponApplyLoader, setCouponApplyLoader] = useState(false);
  const [couponRemoveLoader, setCouponRemoveLoader] = useState(false);
  const [freecashApplyLoader, setFreecashApplyLoader] = useState(false);
  const [freecashRemoveLoader, setFreecashRemoveLoader] = useState(false);
  const [viewCouponPopup, setViewCouponPopup] = useState(false);
  async function addCoupon(code) {
    setCouponApplyLoader(true);
    await create("coupon.php?action=applycoupon", {
      coupon_code: code,
    })
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          message.success(res?.message);
          getCartList();
          setCouponApplyLoader(false);
        } else {
          message.error(res?.message);
          setCouponApplyLoader(false);
        }
      })
      .catch((err) => {
        message.error("Something went wrong");
        setCouponApplyLoader(false);
      });
  }

  async function removeCoupon() {
    setCouponRemoveLoader(true);
    await getAll("coupon.php?action=deletecoupon")
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          message.success(res?.message);
          getCartList();
          setCouponRemoveLoader(false);
        } else {
          message.error(res?.message);
          setCouponRemoveLoader(false);
        }
      })
      .catch((err) => {
        message.error("Something went wrong");
        setCouponRemoveLoader(false);
      });
  }

  async function addFreecash(cash) {
    setFreecashApplyLoader(true);
    await create("cart.php?action=applyfreecash", {
      freecash: cash,
    })
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          message.success(res?.message);
          getCartList();
          setFreecashApplyLoader(false);
        } else {
          message.error(res?.message);
          setFreecashApplyLoader(false);
        }
      })
      .catch((err) => {
        message.error("Something went wrong");
        setFreecashApplyLoader(false);
      });
  }

  async function removeFreecash() {
    setFreecashRemoveLoader(true);
    await getAll("cart.php?action=deletefreecash")
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          message.success(res?.message);
          getCartList();
          setFreecashRemoveLoader(false);
        } else {
          message.error(res?.message);
          setFreecashRemoveLoader(false);
        }
      })
      .catch((err) => {
        message.error("Something went wrong");
        setFreecashRemoveLoader(false);
      });
  }

  async function getCartList() {
    setCartListLoader(true);
    const cart_list = localStorage.getItem("nattu_cart");
    const data = cart_list ? JSON.parse(cart_list).cart_items : [];
    await create("cart.php?action=cartstorage", { cart_items: data })
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          setCartList(res?.data);
          setCouponText(res?.data?.coupon?.applied_coupon || "");
          const update_storage = res?.data?.items?.map((item) => {
            return {
              product_id: item?.product_id,
              quantity: item?.quantity,
              cart_key: item?.cart_key,
              product_type: item?.product_type,
              select_product: item?.select_product,
              select_product_qty: item?.select_product_qty,
              free_product_addon: item?.free_product_addon,
              free_product_qty: item?.free_product_qty,
            };
          });
          localStorage.setItem(
            "nattu_cart",
            JSON.stringify({ cart_items: update_storage }),
          );
          setCartListLoader(false);
          if (localStorage.getItem("nattu_customer_login") === "true") {
            authCartUpdate();
          }
        } else {
          setCartList([]);
          setCartListLoader(false);
        }
      })
      .catch((err) => {
        setCartList([]);
        setCartListLoader(false);
      });
  }
  async function authCartUpdate() {
    const token = localStorage.getItem("nattu_customer_login");
    if (token !== "true") {
      return;
    }
    const cart_list = localStorage.getItem("nattu_cart");
    const data = cart_list ? JSON.parse(cart_list).cart_items : [];
    await create("cart.php?action=authcartstorage", { cart_items: data })
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
        } else {
        }
      })
      .catch((err) => {});
  }

  const getTotalCartQuantity = (cart) => {
    return cart.cart_items.reduce((total, item) => total + item.quantity, 0);
  };

  async function deleteCart(id) {
    setCartDeleteLoader(true);
    try {
      let cart_list = localStorage.getItem("nattu_cart");
      let cart = cart_list ? JSON.parse(cart_list) : { cart_items: [] };
      const itemToDelete = cart.cart_items.find(
        (item) => String(item.cart_key || item.product_id) === String(id)
      );
      const updatedCart = cart.cart_items.filter(
        (item) => (item.cart_key || item.product_id) !== id,
      );
      localStorage.setItem(
        "nattu_cart",
        JSON.stringify({ cart_items: updatedCart }),
      );

      setCartList(updatedCart);
      const totalQuantity = getTotalCartQuantity({ cart_items: updatedCart });
      const storedSession = localStorage.getItem("customer_session");
      let parsedSession = JSON.parse(storedSession);
      if (parsedSession?.value) {
        addSessionOverview(parsedSession.value, totalQuantity);
      }

      if (itemToDelete) {
        CRMTracker('remove_from_cart', {
          productId: itemToDelete.product_id,
          productName: itemToDelete.product_name,
          price: parseFloat(itemToDelete.sp || itemToDelete.mrp || 0),
          quantity: itemToDelete.quantity,
          category: itemToDelete.category_name || null
        });
      }

      setCartDeleteLoader(false);
    } catch (error) {
      setCartDeleteLoader(false);
    }
    getCartList();
  }

  async function addCart(
    product_id,
    quantity = 1,
    customizeData = null,
    productData = null,
  ) {
    setCartAddLoader(true);
    try {
      let cart_list = localStorage.getItem("nattu_cart");
      let cart = cart_list ? JSON.parse(cart_list) : { cart_items: [] };

      // For customize products, create a unique identifier based on selected products
      let cartKey = product_id;
      if (customizeData && customizeData.product_type === "customize") {
        // Unique key combining product_id and selected products
        cartKey = `${product_id}_customize_${customizeData.select_product}`;
      }

      const find_product = cart.cart_items.find((item) =>
        customizeData && customizeData.product_type === "customize"
          ? item.cart_key === cartKey
          : item.product_id === product_id &&
            (!item.product_type || item.product_type !== "customize"),
      );

      if (find_product) {
        find_product.quantity += quantity;
      } else {
        const newItem = { product_id, quantity: 1 };
        if (customizeData) {
          newItem.product_type = customizeData.product_type;
          newItem.select_product = customizeData.select_product;
          newItem.select_product_qty = customizeData.select_product_qty;
          newItem.free_product_addon = customizeData.free_product_addon;
          newItem.free_product_qty = customizeData.free_product_qty;
          newItem.cart_key = cartKey;
        }
        cart.cart_items.push(newItem);
      }
      localStorage.setItem("nattu_cart", JSON.stringify(cart));
      setCartList(cart.cart_items);
      const totalQuantity = getTotalCartQuantity(cart);
      const storedSession = localStorage.getItem("customer_session");
      let parsedSession = JSON.parse(storedSession);
      if (parsedSession?.value) {
        addSessionOverview(parsedSession.value, totalQuantity);
      }

      // Track Add to Cart event with GA4 and Meta Pixel
      if (productData && productData.product_id) {
        trackAddToCart(productData, quantity, "INR");
      }

      const addedItem = cart.cart_items.find(
        (item) => String(item.cart_key || item.product_id) === String(cartKey) || String(item.product_id) === String(product_id)
      );

      CRMTracker('add_to_cart', { 
        productId: product_id, 
        productName: productData?.product_name || productData?.productName || addedItem?.product_name || null,
        price: productData?.sp || productData?.price || (addedItem ? parseFloat(addedItem.sp || addedItem.mrp || 0) : null),
        quantity: quantity,
        productType: customizeData?.product_type || 'standard',
        category: productData?.category_name || productData?.category || addedItem?.category_name || null
      });

      setCartAddLoader(false);
    } catch (error) {
      console.error("Error adding to cart:", error);
      setCartAddLoader(false);
    }
    getCartList();
  }

  async function updateCart(itemKey, cart_type = "plus") {
    setCartUpdateLoader(true);
    try {
      let cart_list = localStorage.getItem("nattu_cart");
      let cart = cart_list ? JSON.parse(cart_list) : { cart_items: [] };
      const find_product = cart.cart_items.find(
        (item) => (item.cart_key || item.product_id) === itemKey,
      );
      if (find_product) {
        if (cart_type === "plus") {
          find_product.quantity += 1;
        } else if (cart_type === "minus") {
          find_product.quantity -= 1;
          if (find_product.quantity <= 0) {
            cart.cart_items = cart.cart_items.filter(
              (item) => (item.cart_key || item.product_id) !== itemKey,
            );
          }
        }
        localStorage.setItem("nattu_cart", JSON.stringify(cart));
        setCartList(cart.cart_items);
        const totalQuantity = getTotalCartQuantity(cart);
        const storedSession = localStorage.getItem("customer_session");
        let parsedSession = JSON.parse(storedSession);
        if (parsedSession?.value) {
          addSessionOverview(parsedSession.value, totalQuantity);
        }
        setCartUpdateLoader(false);
      } else {
        setCartUpdateLoader(false);
      }
    } catch (error) {
      setCartUpdateLoader(false);
    }
    getCartList();
  }

  const addSessionOverview = async (sessionId, totalQuantity) => {
    try {
      const res = await create("cart.php?action=updatecartsession", {
        session_id: sessionId,
        quantity: totalQuantity, // Pass total quantity here
      });

      if (res?.status === 200 && res?.success === true) {
        console.log("Session updated successfully.");
      } else {
        console.error("Failed to update session.");
      }
    } catch (err) {
      console.error("Error in updating session:", err);
    }
  };

  return (
    <Context.Provider
      value={{
        ...props,
        cartListLoader,
        setCartListLoader,
        cartList,
        setCartList,
        getCartList,
        deleteCart,
        cartDeleteLoader,
        setCartDeleteLoader,
        addCart,
        cartAddLoader,
        setCartAddLoader,
        updateCart,
        currentCart,
        setCurrentCart,
        cartUpdateLoader,
        setCartUpdateLoader,
        couponApplyLoader,
        setCouponApplyLoader,
        couponRemoveLoader,
        setCouponRemoveLoader,
        freecashApplyLoader,
        setFreecashApplyLoader,
        freecashRemoveLoader,
        setFreecashRemoveLoader,
        addCoupon,
        removeCoupon,
        addFreecash,
        removeFreecash,
        couponText,
        setCouponText,
        viewCouponPopup,
        setViewCouponPopup,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default CartProvider;
